import darkTheme from './dark';
import lightTheme from './light';
import baseTheme from './base';

export const Theme = {
  Dark: darkTheme,
  Light: lightTheme,
  Base: baseTheme,
};
